import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { userMeKey } from "src/api/client-api/useUserNew";
import {
    SOCIAL_NOTIFICATIONS_KEY,
    SocialNotificationsResponse,
    useSocialNotifications,
} from "src/api/client-api/social/useSocialNotifications";

export const SOCIAL_UNREAD_COUNT_KEY = "social-unread-count" as const;

export const useSocialUnreadCount = () => {
    const query = useSocialNotifications();

    return {
        ...query,
        data: query.data?.unreadCount ?? 0,
    };
};

export const useMarkSocialSeen = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (userId?: number) => {
            if (!userId) {
                return null;
            }

            const seenAt = new Date().toISOString();
            const response = await loggedInApiCall.patch(
                `/api/users/${userId}`,
                {
                    socialLastSeenAt: seenAt,
                },
                {
                    headers: {
                        "Content-Type": "application/merge-patch+json",
                    },
                },
            );

            return response.data;
        },
        onMutate: async () => {
            await queryClient.cancelQueries([SOCIAL_NOTIFICATIONS_KEY]);
            queryClient.setQueriesData<SocialNotificationsResponse | undefined>([SOCIAL_NOTIFICATIONS_KEY], (data) => {
                if (!data) {
                    return data;
                }

                return {
                    ...data,
                    unreadCount: 0,
                };
            });
        },
        onSuccess: () => {
            queryClient.invalidateQueries([userMeKey]);
            queryClient.invalidateQueries([SOCIAL_UNREAD_COUNT_KEY]);
        },
    });
};
